<template>
    <div class="grille">
        <FicheDescriptive v-bind:patientCourant="patientCourant" class="NouvellePage" />
        <div class="block">
            <button v-on:click="affiche">Enregistrer</button>
            <button>Imprimer</button>
            <button>Archiver</button>
            <input type="button" value="Retour" onclick="history.go(-1)">

            <div class="blockUtilisateur">
                <button>Antécedents</button>
                <button>Assurés</button>
                <button>Trait. Longue durée</button>
                <button>Données physiologiques</button>
            </div>
        </div>
    </div>
</template>

<style>
    .grille {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto;
    }

    .block {
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-template-rows: auto;

    }
    .block > button ,.block > input {
        background-color: white;
        border-radius: 10px;
        border: hidden;
        width: 200px;
        height: auto;
        text-align: center;
        padding: 10px;
        margin: 10px;
        font-size: medium;
    }
    .blockUtilisateur > button {
        background-color: white;
        border-radius: 10px;
        border: hidden;
        width: 200px;
        height: auto;
        text-align: center;
        padding: 10px;
        margin: 10px;
        font-size: medium;
    }

</style>
<script>
    import { defineComponent } from 'vue';
    import FicheDescriptive from './FicheDescriptive.vue';
    import Patient from '../script/Patient.js';
    export default defineComponent({
        components: {
            //Les composants
            FicheDescriptive
        },
        data: function () {
            return {
                patientCourant: new Patient({})
            }
        },

        computed: {
            patientCourant() {
                return this.$store.getters["ConnexionStore/getPatientCourant"]
            }
        },

        methods: {
            affiche() {
                console.log("Test :", this.patientCourant);
                Patient.TestPatientSaisie(this.patientCourant);

            }
        },

        props: {
        },
        mounted() {
        }
        ,
        created() {

        }
    });
</script>